import { render, staticRenderFns } from "./mainframe.vue?vue&type=template&id=7d9e7b11&"
import script from "./mainframe.vue?vue&type=script&lang=js&"
export * from "./mainframe.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports